import { render, staticRenderFns } from "./PassengerInformationCard.vue?vue&type=template&id=7bb94c6a"
import script from "./PassengerInformationCard.vue?vue&type=script&lang=ts"
export * from "./PassengerInformationCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports